import React, { useEffect } from 'react';
import { youtubeId, urlEmbebida } from '../services/ayudaService';

// Reproductor de un video de ayuda (YouTube "no listado", sin cookies de seguimiento).
// Si llegan varios videos del mismo módulo, se elige cuál ver con la lista de abajo.
export default function VideoAyudaModal({ videos, inicial = 0, onCerrar }) {
  const [i, setI] = React.useState(inicial);
  const video = videos[i];
  const id = youtubeId(video?.url);

  useEffect(() => {
    const tecla = (e) => { if (e.key === 'Escape') onCerrar(); };
    document.addEventListener('keydown', tecla);
    return () => document.removeEventListener('keydown', tecla);
  }, [onCerrar]);

  if (!video) return null;
  return (
    <div role="dialog" aria-modal="true" aria-label={video.titulo}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1500, padding: '16px' }}
      onClick={onCerrar}>
      <div onClick={(e) => e.stopPropagation()}
        style={{ background: '#fff', borderRadius: '16px', width: '100%', maxWidth: '760px', maxHeight: '92vh', overflowY: 'auto', boxShadow: '0 20px 50px rgba(0,0,0,.25)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px', padding: '14px 16px' }}>
          <b style={{ fontSize: '16px' }}>▶️ {video.titulo}</b>
          <button onClick={onCerrar} className="k-btn-soft" aria-label="Cerrar video">✕</button>
        </div>
        {id ? (
          <div style={{ position: 'relative', paddingTop: '56.25%', background: '#000' }}>
            <iframe title={video.titulo} src={urlEmbebida(id)}
              style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 0 }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin" allowFullScreen />
          </div>
        ) : (
          <p style={{ margin: 0, padding: '24px 16px', color: '#6B7280' }}>
            Este video no se puede mostrar aquí. <a href={video.url} target="_blank" rel="noopener noreferrer">Ábrelo en una pestaña nueva</a>.
          </p>
        )}
        {video.descripcion && <p style={{ margin: 0, padding: '12px 16px 4px', fontSize: '14px', color: '#4B5563' }}>{video.descripcion}</p>}
        {videos.length > 1 && (
          <div style={{ padding: '10px 16px 16px', display: 'grid', gap: '6px' }}>
            <small style={{ color: '#6B7280', fontWeight: 700 }}>Más videos de este tema</small>
            {videos.map((v, j) => (
              <button key={v.id} onClick={() => setI(j)}
                style={{ textAlign: 'left', padding: '10px 12px', borderRadius: '10px', cursor: 'pointer', fontSize: '14px',
                  border: `1px solid ${j === i ? 'var(--color-primario,#DB2777)' : '#E5E7EB'}`, background: j === i ? '#FDF2F8' : '#fff', fontWeight: j === i ? 700 : 500 }}>
                {j === i ? '▶️ ' : ''}{v.titulo}
              </button>
            ))}
          </div>
        )}
        {videos.length <= 1 && <div style={{ height: '12px' }} />}
      </div>
    </div>
  );
}
